export default __webpack_public_path__ + "static/logo-kp.png?71b06b3cf7b3";